import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { PopupContext } from "../../../context/PopupProvider";
import MyButton from "../../../components/MyButton";

const WithdrawMemberDialog = ({ onSubmit }) => {
  const { t } = useTranslation();
  const { closePopup } = useContext(PopupContext);

  const onDelete = () => {
    onSubmit();
    closePopup();
  };

  return (
    <div className="md:p-12 p-8 rounded-2xl bg-white">
      <p className="md:text-2xl text-xl font-medium text-center mb-1">
        탈퇴하시겠습니까?
      </p>
      <p className="md:text-xl text-gray-dark text-center mb-6">
        회원 탈퇴 시 계정 정보는 삭제되어 복구할 수 없습니다.<br />
         정말로{" "}<b className="md:text-xl text-gray-dark font-semibold">탈퇴</b>하시겠습니까?
      </p>
      <div className="flex justify-center items-center gap-4">
        <MyButton onClick={closePopup}>{t("common.buttons.cancel")}</MyButton>
        <MyButton variant="contained" color="#e74c3c" onClick={onDelete}>
          탈퇴
        </MyButton>
      </div>
    </div>
  );
};

export default WithdrawMemberDialog;
